import { useTranslation } from 'react-i18next'
import ChecklistPanel from './ChecklistPanel'
import useDoorToDoorPartnerChecklist from './useDoorToDoorPartnerChecklist'

const DoorToDoorPartnerChecklist = () => {
  const { t } = useTranslation()
  const {
    isDoorToDoorPartner,
    introductionChecklist,
    identityChecklist,
    presentationChecklist,
    visitPurposeChecklist,
    recapChecklist,
    checkedTitles,
    expanded,
    setCheckedTitle,
    toggleExpanded
  } = useDoorToDoorPartnerChecklist()

  if (!isDoorToDoorPartner) return null

  return (
    <div style={{ marginBottom: 16 }}>
      <ChecklistPanel
        idKey='introduction'
        data={introductionChecklist}
        checkedTitles={checkedTitles}
        toggleExpanded={toggleExpanded}
        setCheckedTitle={setCheckedTitle}
        expanded={expanded}
      />
      <ChecklistPanel
        idKey='identity'
        data={identityChecklist}
        checkedTitles={checkedTitles}
        toggleExpanded={toggleExpanded}
        setCheckedTitle={setCheckedTitle}
        expanded={expanded}
      />
      <ChecklistPanel
        idKey='presentation'
        data={presentationChecklist}
        checkedTitles={checkedTitles}
        toggleExpanded={toggleExpanded}
        setCheckedTitle={setCheckedTitle}
        expanded={expanded}
      />
      <ChecklistPanel
        idKey='visitPurpose'
        data={visitPurposeChecklist}
        checkedTitles={checkedTitles}
        toggleExpanded={toggleExpanded}
        setCheckedTitle={setCheckedTitle}
        expanded={expanded}
      />
      <ChecklistPanel
        idKey='recap'
        data={recapChecklist}
        checkedTitles={checkedTitles}
        toggleExpanded={toggleExpanded}
        setCheckedTitle={setCheckedTitle}
        expanded={expanded}
      />
      <p style={{ marginTop: 8, fontStyle: 'italic', fontSize: 14 }}>
        {t('subscriptionForm:door_to_door_partner_checklist.disclaimer')}
      </p>
    </div>
  )
}

export default DoorToDoorPartnerChecklist
